import React, { useState, useEffect } from 'react';
import ResponsiveHeader from '../components/ResponsiveHeader';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';

const CommunityPage = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/community-page`);
      if (response.ok) {
        const data = await response.json();
        setSettings(data);
      }
    } catch (error) {
      console.error('Error fetching community page settings:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-red-50 to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
        <ResponsiveHeader />
        <div className="flex items-center justify-center min-h-[60vh]">
          <p className="text-lg text-gray-600">Loading...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (!settings || !settings.enabled) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-red-50 to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
        <ResponsiveHeader />
        <div className="max-w-7xl mx-auto px-4 py-20">
          <Card>
            <CardContent className="p-12 text-center">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Coming Soon</h2>
              <p className="text-gray-600 dark:text-gray-400">Our community page is currently being updated. Check back soon!</p>
            </CardContent>
          </Card>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-red-50 to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <ResponsiveHeader />
      
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 py-12 mt-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-red-600 to-red-800 bg-clip-text text-transparent mb-4">
            {settings.title}
          </h1>
          {settings.subtitle && (
            <p className="text-xl text-gray-700 mb-6">{settings.subtitle}</p>
          )}
          {settings.description && (
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
              {settings.description}
            </p>
          )}
        </div>

        {/* Image Section */}
        {settings.image_url && (
          <Card className="overflow-hidden shadow-2xl">
            <CardContent className="p-0">
              <img
                key={settings.image_url}
                src={settings.image_url}
                alt={settings.title}
                className="w-full h-auto object-contain"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="400"%3E%3Crect fill="%23ddd" width="800" height="400"/%3E%3Ctext fill="%23999" x="50%25" y="50%25" text-anchor="middle" dominant-baseline="middle" font-size="20"%3EImage not found%3C/text%3E%3C/svg%3E';
                }}
              />
            </CardContent>
          </Card>
        )}

        {/* Additional Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          <Card className="hover:shadow-xl transition-all duration-300">
            <CardContent className="p-6 text-center">
              <div className="text-4xl mb-4">👥</div>
              <h3 className="text-xl font-bold text-red-700 mb-2">Connect</h3>
              <p className="text-gray-600 dark:text-gray-400">Network with trainers and fitness enthusiasts from around the world</p>
            </CardContent>
          </Card>

          <Card className="hover:shadow-xl transition-all duration-300">
            <CardContent className="p-6 text-center">
              <div className="text-4xl mb-4">💪</div>
              <h3 className="text-xl font-bold text-red-700 mb-2">Grow</h3>
              <p className="text-gray-600 dark:text-gray-400">Share your fitness journey and inspire others to achieve their goals</p>
            </CardContent>
          </Card>

          <Card className="hover:shadow-xl transition-all duration-300">
            <CardContent className="p-6 text-center">
              <div className="text-4xl mb-4">🎯</div>
              <h3 className="text-xl font-bold text-red-700 mb-2">Achieve</h3>
              <p className="text-gray-600 dark:text-gray-400">Get motivated and reach your fitness milestones together</p>
            </CardContent>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CommunityPage;
